import { getQueryUrl } from '@/helpers';
import { IUserPermissionsModel } from '@/pages/Auth0/Users/PermissionsTable';
import CrudRequest from '@/services/CrudRequest';
import request from '@/services/request';
import { IRoleModel, IUserModel, Result } from '@/types/base';
import { AgGridRequest } from '@/types/models';
import { isObject } from 'lodash';

class User extends CrudRequest<IUserModel> {
    public override async update<U>(id: string, data: any): Promise<Result<IUserModel>> {
        return request(`/${this.entity}/update`, {
            method: 'POST',
            data: {
                ...data,
                id,
                agencyId: isObject(data.agencyId) ? data.agencyId.key : data.agencyId,
                relatedAgencyId: isObject(data.relatedAgencyId) ? data.relatedAgencyId.key : data.relatedAgencyId,
            },
        });
    }

    private updateHelper(endpoint: string, data: { [key: string]: string | string[] }, defaultId = getQueryUrl()) {
        return request(`/${this.entity}/${endpoint}`, {
            method: 'POST',
            data: { ...data, id: defaultId },
        });
    }

    public async updatePassword(value: string, defaultId = getQueryUrl()) {
        const payload = { password: value };
        return await this.updateHelper('update/password', payload, defaultId);
    }

    public async removeRoleFromUser(role: string, defaultId = getQueryUrl()) {
        return await this.updateHelper('removerolefromuser', { role }, defaultId);
    }

    public async assignRoleToUser(roles: string[], defaultId = getQueryUrl()) {
        return await this.updateHelper('assignroletouser', { roles }, defaultId);
    }

    public async removePermissionFromUser(permission: string) {
        return await this.updateHelper('removepermissionfromuser', { permission });
    }

    public async assignPermissionToUser(permissions: string[]) {
        return await this.updateHelper('assignpermissiontouser', { permissions });
    }

    public async getUsersRoles(params: AgGridRequest): Promise<Result<IRoleModel[]>> {
        return request(`/${this.entity}/getusersroles`, {
            method: 'POST',
            data: { ...params, id: getQueryUrl() },
        });
    }

    public async getUsersPermissions(params: AgGridRequest): Promise<Result<IUserPermissionsModel[]>> {
        return request(`/${this.entity}/getuserspermissions`, {
            method: 'POST',
            data: { ...params, id: getQueryUrl() },
        });
    }

    public async resetUserAuthenticator() {
        return request(`/${this.entity}/${getQueryUrl()}/resetuserauthenticator`, {
            method: 'POST',
        });
    }

    public async userBlocker(block: boolean) {
        return request(`/${this.entity}/block`, {
            method: 'POST',
            data: { block, id: getQueryUrl() },
        });
    }
}

export default new User('user');
